/**
 * Nomi dei cookie di autenticazione, in un posto solo: server e client devono
 * leggere lo stesso nome, e in produzione cambia.
 *
 * In produzione hanno il prefisso `__Host-`: il browser li accetta solo su
 * HTTPS, per il dominio esatto e con `path=/`, quindi un sottodominio non può
 * sovrascriverli. In locale si gira in HTTP, dove quel prefisso li farebbe
 * rifiutare: lì restano senza.
 */
export function sessionCookieName(production: boolean): string {
  return production ? '__Host-evolfin.sid' : 'evolfin.sid';
}

/** Cookie del token CSRF: leggibile dal client, che lo rispedisce in header. */
export function csrfCookieName(production: boolean): string {
  return production ? '__Host-evolfin.csrf' : 'evolfin.csrf';
}
